import mapboxgl from 'mapbox-gl';

const {
    accessToken = null,
    mapboxStyleUsername = null,
    mapboxStyleId = null,
    mapboxLocationImg = null,
} = window.mapbox_config;

mapboxgl.accessToken = accessToken;

const mapBoundsForFeatures = features => {
    const bounds = features.reduce(
        (boundsObject, feature) => boundsObject.extend(feature.geometry.coordinates),
        new mapboxgl.LngLatBounds(),
    );
    return bounds;
};

const createPopup = feature => {
    const markerWidth = 30;
    const markerHeight = 41;
    const offset = 5;

    const popup = new mapboxgl.Popup({
        className: 'map-popup-container',
        closeButton: false,
        maxWidth: 'none',
        offset: {
            top: [0, offset],
            'top-left': [0, offset],
            'top-right': [0, offset],
            bottom: [0, -markerHeight - offset],
            'bottom-left': [0, -markerHeight - offset],
            'bottom-right': [0, -markerHeight - offset],
            left: [markerWidth / 2 + offset, -markerHeight / 2],
            right: [-markerWidth / 2 - offset, -markerHeight / 2],
        },
    })
        .setLngLat(feature.geometry.coordinates)
        .setHTML(feature.properties.popupHTML);
    return popup;
};

const intitializeMap = () => {
    const geojson = JSON.parse(window.mapbox_geojson);
    const isSingleLocation = geojson.features.length === 1;
    const areaOptions = isSingleLocation
        ? {
              center: geojson.features[0].geometry.coordinates,
              zoom: geojson.features[0].properties.zoom,
          }
        : {
              bounds: mapBoundsForFeatures(geojson.features),
              fitBoundsOptions: { padding: 50 },
          };
    const mapOptions = {
        ...areaOptions,
        attributionControl: true,
        container: document.querySelector('[data-map-mount]'),
        cooperativeGestures: true,
        style: `mapbox://styles/${mapboxStyleUsername}/${mapboxStyleId}`,
    };

    const map = new mapboxgl.Map(mapOptions);
    map.addControl(new mapboxgl.NavigationControl());

    map.on('load', () => {
        map.addSource('locations', {
            type: 'geojson',
            data: geojson,
            cluster: true,
            clusterRadius: 60,
        });

        map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'locations',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': '#B65E11',
                'circle-stroke-width': 2,
                'circle-stroke-color': '#fff',
                'circle-radius': ['step', ['get', 'point_count'], 15, 5, 20, 10, 25, 15, 30],
            },
        });

        map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'locations',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': '{point_count_abbreviated}',
                'text-size': 18,
            },
            paint: {
                'text-color': '#fff',
            },
        });

        map.loadImage(mapboxLocationImg, (error, image) => {
            if (error) throw error;

            map.addImage('location-marker', image);

            map.addLayer({
                id: 'markers',
                type: 'symbol',
                source: 'locations',
                filter: ['!', ['has', 'point_count']],
                layout: {
                    'icon-image': 'location-marker',
                    'icon-size': 0.5,
                    'icon-anchor': 'bottom',
                },
            });
        });

        map.on('click', 'clusters', e => {
            const features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
            const clusterId = features[0].properties.cluster_id;
            map.getSource('locations').getClusterExpansionZoom(clusterId, (error, zoom) => {
                if (error) throw error;
                map.easeTo({
                    center: features[0].geometry.coordinates,
                    zoom: zoom,
                });
            });
        });

        map.on('click', 'markers', e => {
            const popup = createPopup(e.features[0]).addTo(map);
        });

        map.on('mouseenter', ['clusters', 'markers'], () => {
            map.getCanvas().style.cursor = 'pointer';
        });

        map.on('mouseleave', ['clusters', 'markers'], () => {
            map.getCanvas().style.cursor = '';
        });
    });
};

const mapboxConsent = window.im.getState().acceptedServices.includes('mapbox');
if (mapboxConsent) {
    intitializeMap();
} else {
    window.addEventListener('consentmanager', e => {
        if (e.detail.service !== 'mapbox' || !e.detail.accepted) {
            return;
        }
        intitializeMap();
    });
}
